import './index.scss'
$(".section8 ul li").eq(0).addClass('active');
$(".section8 ul li").click(function() {
    $(this).toggleClass("active");
    $(this).find(".text").slideToggle();
})